export const Manufacture =
{ // dashboard object start
  path: '/manufacture',
  component: () => import('@/View/Manufacture/Layout/layout.vue'),
  hidden: false,
  redirect: {name: 'ManufactureDashboard'},
  name: 'Manufacture',
  meta: {
    breadCrumb: 'Manufacture',
    title: 'Manufacture',
    icon: 'dashboard',
    selected: false,
    permission: ['abc', 'def']
  },
  children: [{
    path: 'dashboard',
    icon: 'dashboard',
    component: () => import('@/View/Manufacture/Dashbord/dashboard.vue'),
    name: 'ManufactureDashboard',
    meta: {
      breadCrumb: 'Dashboards',
      title: 'Dashboard',
      icon: 'dashboard',
      permissionList: ['abc', 'def']
    }
  },
  { // activityLog page
    path: 'activityLog',
    component: () => import('@/View/Manufacture/main/index.vue'),
    hidden: false,
    redirect: {name: 'MActivityLog'},
    name: 'ManufactureactivityLog',
    meta: {
      breadCrumb: 'Activity Log',
      title: 'Activity Log',
      icon: 'fas fa-clock',
      selected: false,
      permissionList: ['abc', 'def']
    },
    children: [{
      path: '',
      component: () => import('@/View/Manufacture/ActivityLog/index.vue'),
      name: 'MActivityLog',
      meta: {
        breadCrumb: 'Activity Log',
        icon: 'fas fa-clock',
        title: 'Activity Log',
        permissionList: ['abc', 'def']
      }
    }]
  },
  { // Work Order object start
    path: 'workorder',
    component: () => import('@/View/Manufacture/main/index.vue'),
    hidden: false,
    redirect: {name: 'WorkOrderList'},
    name: 'WorkOrder',
    meta: {
      breadCrumb: 'WorkOrder',
      title: 'WorkOrder',
      icon: 'fa fa-shopping-basket',
      selected: false,
      permissionSlug: 'work_order',
      permissionList: ['isViewAll', 'isViewRelated']
    },
    children: [{
      path: 'list',
      component: () => import('@/View/Manufacture/WorkOrder/workOrders.vue'),
      name: 'WorkOrderList',
      meta: {
        breadCrumb: 'WorkOrderList',
        icon: 'fa fa-shopping-basket',
        title: 'List',
        permissionSlug: 'work_order'
      }
    },
    {
      path: 'new:orderId',
      component: () => import('@/View/Manufacture/WorkOrder/NewWorkOrder.vue'),
      name: 'NewWorkOrder',
      meta: {
        breadCrumb: 'New Work Order',
        icon: 'fa fa-shopping-basket',
        title: 'Add',
        permissionList: []
      }
    },
    {
      path: 'details/:workOrderId',
      component: () => import('@/View/Manufacture/WorkOrder/WorkDetails.vue'),
      name: 'WorkDetails',
      meta: {
        breadCrumb: 'Work Order Details',
        icon: 'fa fa-shopping-basket',
        title: 'Details',
        permissionList: []
      }
    },
    {
      path: 'new/report/:workResourceId/:reportId/:workOrderId',
      component: () => import('@/View/Manufacture/WorkOrder/NewReport.vue'),
      name: 'NewReport',
      meta: {
        breadCrumb: 'New Report',
        icon: 'fa fa-shopping-basket',
        title: 'New Report',
        permissionList: []
      }
    },
    {
      path: 'report/details/:reportId/:workOrderId',
      component: () => import('@/View/Manufacture/WorkOrder/reportDetails.vue'),
      name: 'reportDetails',
      meta: {
        breadCrumb: 'Report Details',
        icon: 'fa fa-shopping-basket',
        title: 'Report Details',
        permissionList: []
      }
    },
    {
      path: 'new/serialnumber/:workOrderId',
      component: () => import('@/View/Manufacture/WorkOrder/NewSerialNumber.vue'),
      name: 'NewSerialNumber',
      meta: {
        breadCrumb: 'New Serial Number',
        icon: 'fa fa-shopping-basket',
        title: 'New Serial Number',
        permissionList: []
      }
    },
    {
      path: 'generate/qaprocess/:workOrderId',
      component: () => import('@/View/Manufacture/WorkOrder/GenerateQAProcess.vue'),
      name: 'GenerateQAProcess',
      meta: {
        breadCrumb: 'New QA Process',
        icon: 'fa fa-shopping-basket',
        title: 'New QA Process',
        permissionList: []
      }
    }]
  },
  { // Setting object start
    path: '/setting',
    component: () => import('@/View/Manufacture/main/index.vue'),
    hidden: false,
    redirect: {name: 'SettingsDashboard'},
    name: 'ManuSettings',
    meta: {
      breadCrumb: 'Settings',
      title: 'Settings',
      icon: 'fa fa-cog',
      selected: true,
      permissionSlug: 'manfacturing_settings',
      permissionList: ['']
    },
    children: [{
      path: 'dashboard',
      component: () => import('@/View/Manufacture/Setting/setting.vue'),
      name: 'SettingsDashboard',
      hidden: true,
      meta: {
        breadCrumb: 'Settings',
        icon: 'fa fa-cog',
        title: 'Dashboard',
        selected: false,
        permissionList: ['']
      }
    },
    { // Machine List page
      path: 'machine',
      component: () => import('@/View/Manufacture/main/index.vue'),
      hidden: false,
      redirect: {name: 'MachineList'},
      name: 'Machine',
      icon: 'fas fa-tools',
      meta: {
        breadCrumb: 'Machine',
        title: 'Machine',
        icon: 'fas fa-tools',
        color: '#1976d2',
        selected: true,
        permissionList: ['isViewAll'],
        permissionSlug: 'machine_management'
      },
      children: [{
        path: 'list',
        component: () => import('@/View/Manufacture/Setting/Machine/machinelist.vue'),
        name: 'MachineList',
        meta: {
          breadCrumb: 'Machine',
          icon: 'fas fa-tools',
          title: 'Machine',
          permissionSlug: 'Machine'
        }
      },
      {
        path: 'new:machineId',
        component: () => import('@/View/Manufacture/Setting/Machine/NewMachine.vue'),
        name: 'NewMachine',
        meta: {
          breadCrumb: 'New Machine',
          icon: 'fas fa-tools',
          title: 'New Machine',
          permissionSlug: 'Machine'
        }
      },
      {
        path: 'details:machineId',
        component: () => import('@/View/Manufacture/Setting/Machine/MachineDetails.vue'),
        name: 'MachineDetails',
        meta: {
          breadCrumb: 'Machine Details',
          icon: 'fas fa-tools',
          title: 'Machine Details',
          permissionSlug: 'Machine'
        }
      }]
    },
    { // WorkCenter List page
      path: 'workcenter',
      component: () => import('@/View/Manufacture/main/index.vue'),
      hidden: false,
      redirect: {name: 'WorkCenterC'},
      name: 'WorkCenter',
      icon: 'fas fa-building',
      meta: {
        breadCrumb: 'WorkCenter',
        title: 'WorkCenter',
        color: '#4caf50',
        selected: false,
        permissionList: ['isViewAll'],
        permissionSlug: 'work_center'
      },
      children: [{
        path: 'list',
        component: () => import('@/View/Manufacture/Setting/Workcenter/workcenterList.vue'),
        name: 'WorkCenterC',
        meta: {
          breadCrumb: 'WorkCenter',
          icon: 'fas fa-tools',
          title: 'WorkCenter',
          permissionSlug: 'WorkCenter'
        }
      },
      {
        path: 'new:workCenterId',
        component: () => import('@/View/Manufacture/Setting/Workcenter/NewWorkCenter.vue'),
        name: 'NewWorkCenter',
        meta: {
          breadCrumb: 'New WorkCenter',
          icon: 'fas fa-building',
          title: 'New WorkCenter',
          permissionSlug: 'WorkCenter'
        }
      },
      {
        path: 'details:workCenterId',
        component: () => import('@/View/Manufacture/Setting/Workcenter/WorkcenterDetails.vue'),
        name: 'WorkCenterDetails',
        meta: {
          breadCrumb: 'WorkCenter Details',
          icon: 'fas fa-tools',
          title: 'WorkCenter Details',
          permissionSlug: 'WorkCenter'
        }
      }]
    },
    { // Questions List page
      path: 'category',
      component: () => import('@/View/Manufacture/main/index.vue'),
      hidden: false,
      redirect: {name: 'ManfCategoryList'},
      name: 'Category',
      icon: 'fa fa-question-circle',
      meta: {
        breadCrumb: 'Category',
        title: 'Questions',
        color: '#2196f3',
        selected: false,
        permissionList: ['isViewAll'],
        permissionSlug: 'manufacturing_questions'
      },
      children: [{
        path: 'list',
        component: () => import('@/View/Manufacture/Setting/Questions/categoryList.vue'),
        name: 'ManfCategoryList',
        meta: {
          breadCrumb: 'Category',
          icon: 'fas fa-tools',
          title: 'Category',
          permissionSlug: 'manufacturing_questions'
        }
      },
      {
        path: 'details:categoryId',
        component: () => import('@/View/Manufacture/Setting/Questions/categoryDetails.vue'),
        name: 'CategoryDetails',
        meta: {
          breadCrumb: 'Category Details',
          icon: 'fas fa-tools',
          title: 'Category Details',
          permissionSlug: 'manufacturing_questions'
        }
      },
      {
        path: 'new:questionId:categoryId',
        component: () => import('@/View/Manufacture/Setting/Questions/NewQuestion.vue'),
        name: 'NewQuestion',
        meta: {
          breadCrumb: 'New Question',
          icon: 'fas fa-tools',
          title: 'New Question',
          permissionSlug: 'manfacturing_questions'
        }
      },
      {
        path: 'question/details:questionId',
        component: () => import('@/View/Manufacture/Setting/Questions/questiondetails.vue'),
        name: 'QuestionDetails',
        meta: {
          breadCrumb: 'Question Details',
          icon: 'fas fa-tools',
          title: 'Question Details',
          permissionSlug: 'manufacturing_questions'
        }
      }]
    },
    { // WorkOrderStatus List page
      path: 'workorder/status',
      component: () => import('@/View/Manufacture/main/index.vue'),
      hidden: false,
      redirect: {name: 'WorkOrderStatusList'},
      name: 'WorkOrderStatus',
      icon: 'fas fa-info',
      meta: {
        breadCrumb: 'Work Order Status',
        title: 'Work Order status',
        color: '#00bcd4',
        selected: false,
        permissionSlug: 'work_order_status',
        permissionList: ['isViewAll']
      },
      children: [{
        path: 'list',
        component: () => import('@/View/Manufacture/Setting/WorkOrderStatus/WorkOrderStatus.vue'),
        name: 'WorkOrderStatusList',
        meta: {
          breadCrumb: 'Work Order Status',
          icon: 'fas fa-tools',
          title: 'Work Order Status',
          permissionSlug: 'work_order_status'
        }
      }]
    },
    { // Work Center Status List page
      path: 'workcenter/status',
      component: () => import('@/View/Manufacture/main/index.vue'),
      hidden: false,
      redirect: {name: 'workCenterStatusList'},
      name: 'workCenterStatus',
      icon: 'far fa-snowflake',
      meta: {
        breadCrumb: 'Work Center Status',
        title: 'Work Center Status',
        color: '#f52549',
        selected: false,
        permissionList: ['isViewAll'],
        permissionSlug: 'work_center_status'
      },
      children: [{
        path: 'list',
        component: () => import('@/View/Manufacture/Setting/WorkCenterStatus/WorkcenterStatus.vue'),
        name: 'workCenterStatusList',
        meta: {
          breadCrumb: 'Work Center Status',
          icon: 'fas fa-tools',
          title: 'Work Center Status',
          permissionSlug: 'work_center_status'
        }
      }]
    }]
  }]
}



// WEBPACK FOOTER //
// ./src/View/Manufacture/Router/index.js